import React from 'react';
import { string } from 'prop-types';

import { SvgIcon } from '../../../svg-icon';
import { ReactQuillWrapped } from '../../../react-quill';
import { Wrapper, Button, MeetingInfoPopover, ReactQuillWrappedContainer } from './styles';

const MeetingInfo = ({ meetingInfo }) => (
  <Wrapper>
    <MeetingInfoPopover
      content={
        <ReactQuillWrappedContainer onClick={(e) => { e.stopPropagation(); }}>
          <ReactQuillWrapped theme={null} value={meetingInfo} readOnly />
        </ReactQuillWrappedContainer>
      }
    >
      <Button>
        <SvgIcon
          type="info"
          isWithoutHover
          fillOpacity={0.7}
          style={{ marginRight: '3px' }}
        />
        Additional info
      </Button>
    </MeetingInfoPopover>
  </Wrapper>
);


MeetingInfo.propTypes = {
  meetingInfo: string.isRequired,
};


export { MeetingInfo };



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-info/index.js